import { Standard } from '@getvim/vim-connect';

export const visitType: Standard.Entities.VisitType = {
  ehrVisitTypeId: '',
  visitTypeName: '',
  visitTypeDesc: '',
  duration: '',
};
